module.exports = __webpack_public_path__ + "img/placeholder.1632e46a.png";